import React from "react";
import Button from '@mui/material/Button';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import useRoomTypeHook from "./roomTypeHook";

const initialState = {
    activeStatus: false,
    roomTypeCode: "",
    roomTypeName: "",
    description: "",
}
const RoomType = () => {
    const {
        roomTypeState,
        handleInputChange,
        handleRoomTypeSubmit,
        handleGoBack
    } = useRoomTypeHook(initialState)
    return (
        <>

            <form>
                <div className="basic-info" >
                    <div className="mt-2 ml-4">
                        <h4>Room Type</h4>
                        <div className="back-btn"
                            onClick={handleGoBack}
                        >
                            <ArrowBackIcon className="arrow-color" />
                            <span
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Room Code*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AccountBalanceIcon /></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Room Code" name="roomTypeCode"
                                        value={roomTypeState?.roomTypeCode}
                                        onChange={handleInputChange} required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Room Name*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <input
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="text" className="form-control"
                                        placeholder="Room Name" name='roomTypeName'
                                        value={roomTypeState?.roomTypeName}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Active Status*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <select
                                        className={"form-control"}
                                        selected={roomTypeState?.activeStatus}
                                        value={roomTypeState?.activeStatus}
                                        onChange={handleInputChange}
                                        required
                                        name="activeStatus"
                                    >
                                        <option></option>
                                        <option value={true}>Yes</option>
                                        <option value={false}>No</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Description</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <textarea
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="text" className="form-control"
                                        placeholder="Description" name='description'
                                        value={roomTypeState?.description}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2"
                        onClick={(event) => {
                            handleRoomTypeSubmit(event)
                        }}
                    >Add Rooms</Button>
                </div>
            </form>
        </>
    )
};

export default RoomType;